import React from 'react';
import ReactDOM from 'react-dom/client';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import '@lili/lili-frontend-common/dist/styles.css';
import './index.css';
import { QueryClient, QueryClientProvider, QueryCache } from 'react-query';
import './services/bugsnag.service';
import { PrimeReactProvider } from 'primereact/api';
import App from './App';
import reportWebVitals from './reportWebVitals';

export const routerHistory = createBrowserHistory({ window });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
export const queryClient = new QueryClient({
  queryCache: new QueryCache(),
});

root.render(
  <QueryClientProvider client={queryClient} contextSharing>
    {/* @ts-ignore */}
    <HistoryRouter history={routerHistory}>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </HistoryRouter>
  </QueryClientProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
